import StateSyncService from './StateSyncService';

export default StateSyncService;
